import React from 'react';
import { Box, HStack, VStack } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import DropdownMenu from '../../../../../../../components/DropdownMenu';
import FormInput from '../../../../../../../components/form/FormInput';
import InputLabel from '../../../../../../../components/form/InputLabel';
import { countries } from '../../../../../../../constants/countries';
import { getValidationObject } from '../../../../../../../constants/regexPatterns';
import UseFormMethodsType from '../../../../../../../types/UseFormMethodsType';

function AddressForm({ useFormMethods, setCountry, selectedCountry, visible }) {
  return visible && (
    <form>
      <VStack alignItems="flex-start" pb={4} spacing={0} width="100%">
        <FormInput
          inputName="insured_address"
          labelName="Address"
          placeholder="Address"
          useFormMethods={useFormMethods}
        />
        <HStack alignItems="flex-start" spacing={6} width="100%">
          <FormInput
            inputName="insured_city"
            labelName="City"
            placeholder="City"
            useFormMethods={useFormMethods}
            validationRules={getValidationObject('alphaAndCharacters')}
          />
          <FormInput
            inputName="insured_state"
            labelName="State"
            placeholder="State"
            useFormMethods={useFormMethods}
            validationRules={{
              maxLength: { value: 2, message: "State's 2-letter abbreviation" },
              ...getValidationObject('alpha')
            }}
          />
          <FormInput
            inputName="insured_zip"
            labelName="Postal Code"
            placeholder="Postal Code"
            useFormMethods={useFormMethods}
            validationRules={{
              maxLength: { value: 10, message: 'Postal code must be 10 characters or less' },
              ...getValidationObject('zipCode')
            }}
          />
        </HStack>
        <Box mb="26px" w="31%">
          <InputLabel labelName="Country" />
          <DropdownMenu
            idKey="code"
            labelKey="name"
            options={countries}
            selected={selectedCountry.code}
            width="100%"
            onSelect={selected => setCountry({ code: selected.value, name: selected.label })}
          />
        </Box>
      </VStack>
    </form>
  );
}

AddressForm.propTypes = {
  useFormMethods: UseFormMethodsType,
  selectedCountry: PropTypes.shape({ code: PropTypes.string }),
  setCountry: PropTypes.func,
  visible: PropTypes.bool,
  formRef: PropTypes.shape({ current: PropTypes.node })
};

export default AddressForm;
